import React from 'react';
import {useCreateMiitelCallProspectActivityMutation, MiitelSetting} from 'api';
import {miitelCall, mountMiitelWidget} from 'helpers/miitelWidget';

const useMiitel = (prospectPoolUuid: string, miitelSetting: MiitelSetting) => {
  const [createMiitelCallProspectActivity] =
    useCreateMiitelCallProspectActivityMutation();

  React.useEffect(() => {
    if (
      !miitelSetting?.isAvailable ||
      !miitelSetting?.isActive ||
      !prospectPoolUuid
    )
      return;

    return mountMiitelWidget(miitelSetting, (miitelSequenceId) =>
      createMiitelCallProspectActivity({
        variables: {prospectPoolUuid, miitelSequenceId},
      }),
    );
  }, [miitelSetting, prospectPoolUuid]);
};

export {useMiitel, miitelCall};
